import React from "react"

import { Action } from "shared/types/Action"

import { ProjectActionsOverlay } from "./ProjectActionsOverlay"
import { useProjectActionsOverlayModel } from "./hooks/useProjectActionsOverlayModel"

export interface ProjectActionsOverlayPayload {
  projectID: string
  isReduced?: boolean
  additionalActions?: Action[]
}

export interface ProjectActionsOverlayConnectorProps {
  payload: ProjectActionsOverlayPayload
}

export const ProjectActionsOverlayConnector = React.memo(
  (props: ProjectActionsOverlayConnectorProps) => (
    <ProjectActionsOverlay {...useProjectActionsOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROJECT_ACTIONS_OVERLAY: ProjectActionsOverlayPayload
  }
}
